import { ref } from "vue";

export const openFlyoutId = ref<string | null>(null);
